import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";
import {setSuccessSocials} from "../../slice/leave-review/postLeaveReviewSlice";


interface ILeaveReview {
    text: string,
    social: string
}

export const postLeaveReview = createAsyncThunk(
    "leaveReview",
    async ({text, social}: ILeaveReview, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.post("/api/profile/review",
                {text, social},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            if(response.data) {
                thunkAPI.dispatch(setSuccessSocials(response.data))

            }
            if (!response.data) {
                throw new Error("Response data is empty");
            }
            return response.data;
        } catch (error) {
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);